export const errorMessage = (message: string) => {
    return message === "fetch timeout" ? "Fetch Timeout, Reload Page" : "Relogin To Refresh Session"
}